let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("jKDWa")]).then(() => parcelRequire('jRIB1'));